import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

export interface Blog {
  id: string;
  brandId: string;
  title: string;
  slug: string;
  excerpt?: string;
  author?: string;
  featuredImage?: string;
  publishedDate?: string;
}

export interface BlogDetail extends Blog {
  content: string;
}

export interface BlogsResponse {
  data: Blog[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

/**
 * Get all published blogs for a brand
 */
export const getPublishedBlogs = async (
  brandId: string,
  page: number = 1,
  limit: number = 10
): Promise<BlogsResponse> => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/web/brand/${brandId}/blogs`,
      {
        params: { page, limit },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching blogs:', error);
    throw error;
  }
};

/**
 * Get a single published blog by slug
 */
export const getPublishedBlogBySlug = async (
  brandId: string,
  slug: string
): Promise<BlogDetail> => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/web/brand/${brandId}/blogs/slug/${slug}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching blog by slug:', error);
    throw error;
  }
};

/**
 * Get a single published blog by ID
 */
export const getPublishedBlogById = async (
  brandId: string,
  blogId: string
): Promise<BlogDetail> => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/web/brand/${brandId}/blogs/${blogId}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching blog by ID:', error);
    throw error;
  }
};

